import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch transport list
 * @param {Object} filters
 *  @param {Number} page Page number
 *  @param {Number} size list size
 *  @param {String} name search transport by name
 *  @param {String} sort sort transport by, format: field;ASC|DESC
 */
const fetchTransportList = async function (filters) {
  try {
    let res = await axios.get(urls.transportList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a transport's detail
 * @param {Number} transportId transport id
 */
const fetchTransportDetail = async function (transportId) {
  try {
    let res = await axios.get(urls.transportDetail + '/' + transportId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create and edit Transport
 * @param {Object} form submitted form
 * @param {String} form.name transport name
 * @param {Number} form.length transport length
 * @param {Number} form.width transport width
 * @param {Number} form.height transport height
 * @param {Number} form.volume transport volume
 * @param {Number} form.maxWeight transport maxWeight
 * @param {String} form.imageUrl transport imageUrl
 * @param {Number} [userId] Transport Type Id
 */
const createEditTransport = async function (form, userId) {
  try {
    let res
    if (!userId) {
      res = await axios.post(urls.transportDetail, form)
    } else {
      res = await axios.put(urls.transportDetail + '/' + userId, form)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Set transport's activation status
 * @param {Number} transportId Transport's Id
 * @param {Number} clientId Transport's company client ID
 * @param {Number} isActive set the transport's activation in binary boolean (1|0)
 */
const setTransportActivation = async function (transportId, clientId, isActive) {
  try {
    let data = {
      clientId,
      transportId,
      isActive
    }
    let res = await axios.post(urls.transportActivation, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchTransportList,
  createEditTransport,
  fetchTransportDetail,
  setTransportActivation,
}
